import { render, staticRenderFns } from "./agentData.vue?vue&type=template&id=320dde62&scoped=true&"
import script from "./agentData.vue?vue&type=script&lang=js&"
export * from "./agentData.vue?vue&type=script&lang=js&"
import style0 from "./agentData.vue?vue&type=style&index=0&id=320dde62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320dde62",
  null
  
)

export default component.exports